import { useEffect, useRef, useState } from "react";
import { Shield, TrendingDown, Clock, Star, Users, CheckCircle2 } from "lucide-react";
interface AnimatedStatsBarProps {
  practiceCount: number;
  cityName: string;
}
const AnimatedStatsBar = ({
  practiceCount,
  cityName
}: AnimatedStatsBarProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, []);
  const stats = [{
    icon: Shield,
    value: practiceCount,
    suffix: "",
    label: `Praxen in ${cityName}`,
    delay: 0
  }, {
    icon: TrendingDown,
    value: "380.000",
    suffix: "€",
    label: "Ø Schaden verhindert",
    delay: 100
  }, {
    icon: Clock,
    value: "2",
    prefix: "< ",
    suffix: " Std.",
    label: "Reaktionszeit Notfall",
    delay: 200
  }, {
    icon: Users,
    value: "15",
    suffix: " Jahre",
    label: "Erfahrung",
    delay: 300
  }, {
    icon: CheckCircle2,
    value: "98",
    suffix: "%",
    label: "Schadenabwicklung",
    delay: 400
  }];
  return <div ref={ref} className="w-full py-8">
      <div className="flex gap-3 sm:gap-4 px-4 justify-center flex-wrap md:flex-nowrap">
        {stats.map((stat, index) => {
        const Icon = stat.icon;
        // Hide last 2 cards on mobile (index 3 and 4)
        const isHiddenOnMobile = index >= 3;
        return <div key={index} className={`
                flex-shrink-0 w-[calc(50%-0.375rem)] sm:w-40 lg:w-44
                bg-card/30 backdrop-blur-sm 
                border border-border/50 
                rounded-lg p-4 sm:p-6
                hover:border-accent/50 hover:bg-card/50 
                transition-all
                ${isHiddenOnMobile ? 'hidden md:flex md:flex-col' : 'flex flex-col'}
                ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
              `} style={{
          transitionDelay: `${stat.delay}ms`,
          transitionDuration: '600ms'
        }}>
              <div className="flex items-center justify-center gap-3 mb-2 sm:mb-3">
                <div className="p-1.5 sm:p-2 bg-accent/20 rounded-lg">
                  <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-accent" />
                </div>
              </div>
              <div className="space-y-1 text-center">
                <div className="flex items-center justify-center gap-1">
                  {stat.prefix && <span className="text-sm sm:text-base font-bold text-foreground">{stat.prefix}</span>}
                  <span className="text-base sm:text-lg font-bold text-foreground">
                    {stat.value}
                  </span>
                  {stat.suffix && <span className="text-sm sm:text-base font-bold text-foreground">{stat.suffix}</span>}
                </div>
                <p className="text-[10px] sm:text-xs text-muted-foreground leading-tight">
                  {stat.label}
                </p>
              </div>
            </div>;
      })}
      </div>
    </div>;
};
export default AnimatedStatsBar;